import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Service.css';
import image2 from '../../assets/images/powder-coating-5053644_1280.jpg';
import image3 from '../../assets/images/side-view-man-working-with-paint-gun.jpg';
import image1 from '../../assets/images/blue-pads-wheel-car (1).jpg';

const CEDServices = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/Service');
    window.scrollTo({ top: 0, behavior: 'instant' }); // scrolls to top instantly
  };

  return (
    <div className="ced-services-container">
      <div className="ced-services-header">
        <h3 className="ced-services-subtitle">Reliable CED Coating Services</h3>
        <h1 className="ced-services-title">
          Serving Diverse Industries and Facilities with Comprehensive Services
        </h1>
      </div>
      <div className="ced-services-grid">
        {/* Card 1 */}
        <div className="ced-services-card">
          <img src={image1} alt="CED Process" className="ced-services-image" />
          <div className="ced-services-content">
            <h2 className="ced-services-card-title">CED / ED / KTL Coating Process</h2>
            <p className="ced-services-card-subtitle">
              The CED/ED/KTL coating process provides a uniform, corrosion-resistant finish through advanced electrochemical deposition on metal surfaces...
            </p>
            <button className="ced-services-button no-underline" onClick={handleNavigate}>
              Explore More <span className="arrow">→</span>
            </button>
          </div>
        </div>

        {/* Card 2 */}
        <div className="ced-services-card">
          <img src={image2} alt="Powder Coating" className="ced-services-image" />
          <div className="ced-services-content">
            <h2 className="ced-services-card-title">Powder Coating Process</h2>
            <p className="ced-services-card-subtitle">
              The Powder Coating process applies a durable, high-quality finish to metal surfaces using electrostatically charged powder, cured under heat for a long-lasting...
            </p>
            <button className="ced-services-button no-underline" onClick={handleNavigate}>
              Explore More <span className="arrow">→</span>
            </button>
          </div>
        </div>

        {/* Card 3 */}
        <div className="ced-services-card">
          <img src={image3} alt="Spray Painting" className="ced-services-image" />
          <div className="ced-services-content">
            <h2 className="ced-services-card-title">Liquid Spray Painting</h2>
            <p className="ced-services-card-subtitle">
              The Liquid Spray Painting process involves applying a smooth, even coat of liquid paint to surfaces using a spray gun, providing a high-quality finish...
            </p>
            <button className="ced-services-button no-underline" onClick={handleNavigate}>
              Explore More <span className="arrow">→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CEDServices;
